/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_use_5 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze usage patterns to improve user experience`)
};

const es_privacy_use_5 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizar patrones de uso para mejorar la experiencia del usuario`)
};

const de_privacy_use_5 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzungsmuster zu analysieren, um die Benutzererfahrung zu verbessern`)
};

const nl_privacy_use_5 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebruikspatronen te analyseren om de gebruikerservaring te verbeteren`)
};

const fr_privacy_use_5 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyser les habitudes d’utilisation pour améliorer l’expérience utilisateur`)
};

const it_privacy_use_5 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizzare i modelli di utilizzo per migliorare l’esperienza utente`)
};

const pt_br2_privacy_use_5 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisar padrões de uso para melhorar a experiência do usuário`)
};

const pt_privacy_use_5 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisar padrões de utilização para melhorar a experiência do utilizador`)
};

const ja_privacy_use_5 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用パターンの分析によるユーザー体験の改善`)
};

const zh_privacy_use_5 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分析使用模式以改善用户体验`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_use_5 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_use_5(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_use_5", locale)
	if (locale === "en") return en_privacy_use_5(inputs)
	if (locale === "es") return es_privacy_use_5(inputs)
	if (locale === "de") return de_privacy_use_5(inputs)
	if (locale === "nl") return nl_privacy_use_5(inputs)
	if (locale === "fr") return fr_privacy_use_5(inputs)
	if (locale === "it") return it_privacy_use_5(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_use_5(inputs)
	if (locale === "pt") return pt_privacy_use_5(inputs)
	if (locale === "ja") return ja_privacy_use_5(inputs)
	return zh_privacy_use_5(inputs)
};